import { makeStyles } from '@material-ui/core';

const stylesAtivacaoConcluida = makeStyles({
  titulo: {
    color: "#2F4050",
    fontSize: "1.5rem"
  },
  containerImagem: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    flexDirection: "column",
  },
  imagem: {
    maxWidth: "100%",
    height: "65vh",
    position: "relative",
    top: "-20%",
  },
  icone: {
    position: "absolute",
    left: "50%", 
    top: "50%", 
    transform: "translate(-50%, -50%)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  textoConclusao: {
    fontSize: "1.7rem",
    marginTop: "1.5rem",
    textAlign: "center",
    transform: "translateX(-50%, -50%)",
  },

  containerAtendimento: {
    display: "flex", 
    justifyContent: "center", 
    alignItems: "center", 
    borderRadius: 5, 
    marginBottom: 20
  },
  textoAtendimento: {
    backgroundColor: "#F1F1F1", 
    padding:20, 
    textAlign: "center"
  },
  nossoConsultor: {
    color: "#2F4050",
    fontWeight: 600
  },
  linkEntreEmContato: {
    color: '#888888',
  }
});

export default stylesAtivacaoConcluida;
